export enum Colors {
  TextMain = '#333333',
  TextSecondary = '#66788A',
  SemanticErrorMain = '#FB7272',
  BrandGreenMain = '#35CE8D',
  Neutralwhite = '#fff',
  Neutral02 = '#EBF1F7',
  Neutral03 = '#CEDBEA',
  Neutral04 = '#9CA9B7',
  Neutral05 = '#66788A',
  PrimaryMain = '#00AFEF',
}
